// extracted by mini-css-extract-plugin
export default {"objetsscene":"IconBox_objetsscene__n71UK","hidden":"IconBox_hidden__NmDDo","iconBoxIcon":"IconBox_iconBoxIcon__+BYN7","panIcon":"IconBox_panIcon__2LOj5"};